import { AfterViewInit, Component, ElementRef, HostListener, Injector, Input,
    NgZone, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';

import { Observable, Subscription, of } from 'rxjs';
import { filter } from 'rxjs/operators';

import { ChartModel } from '../../../Charts/models/chart.model';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { FullProfileAnimationModel } from '../../../../Core/Dialogs/models/full-profile-animation.model';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { ReportBlockTypeEnum, reportChartInfoMap } from '../../enums/report-block-type.enum';
import { BlockModel } from '../../../PageBuilder/models/block.model';
import { ReportsPageBuilderService } from '../../services/reports-page-builder.service';
import { MentionSearchService } from '../../../../Monitor/Core/services/mention-search.service';
import { ReportsChartDetailService } from '../../services/reports-chart-detail.service';
import { DropdownOptionModel } from '../../../Forms/models/dropdown-option.model';
import { DialogIoModel } from '../../../../Core/Dialogs/models/dialog-io.model';
import { TargetingRhpContextsService } from '../../../TargetingShared/services/targeting-rhp-contexts.service';
import { Mention } from '../../../Mentions/models/mention';
import { MentionsService } from '../../../../Monitor/Core/services/mentions.service';
import { MentionDetailsTakeOverPanelComponent } from '../../../Mentions/components/MentionDetailsTakeOverPanel/mention-details-take-over-panel.component';
import { TargetingSearch } from '../../../../Discover/Targeting/models/targeting-search.model';
import { TargetingSearchService } from '../../../../Discover/Targeting/services/targeting-search.service';
import { TargetingRhpDialogService } from '../../../TargetingShared/services/targeting-rhp-dialog.service';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { userPermissionsEnum } from '../../../../Core/Users/enums/user-permissions.enum';
import { RightSidebarComponent } from '../../../Layout/components/RightSidebar/right-sidebar.component';
import { EntityType } from '../../../../api/targeting/enum/entity.type.enum';
import { SearchModeEnum } from '../../../TargetingShared/enum/search-mode.enum';
import { MentionSearchCriteriaModel } from '../../../../Monitor/Shared/models/mention-search-criteria.model';
import { MentionSearchFacetTypesEnum } from '../../../../api/mentions/enum/mention-search-facet-types.enum';
import { EntityTakeoverModel } from '../../../RhpContexts/models/entity-takeover.model';
import { defaultDateTypeOptions, savedSourceDateTypeOptions } from '../../../Forms/components/DateRangeSelector/date-range-selector.component';
import { getDefaultDateInputOptionValuesModel } from '../../../Forms/models/date-query-input-options.model';
import { MonitoringBulkActionDialogComponent } from '../../../../Monitor/Shared/components/MonitoringBulkActionDialog/monitoring-bulk-action-dialog.component';
import { DateQueryModel } from '../../../Forms/models/date-query.model';
import { MonitoringRouteModel } from '../../../../Monitor/Shared/models/monitoring-route.model';
import { RouteType } from '../../../../Monitor/Shared/enums/route-type.enum';
import { TopicsService } from '../../../../Monitor/Core/services/topics.service';
import { MentionSearchModel } from '../../../../Monitor/Shared/models/mention-search.model';
import { MonitoringBackEndDataSourceModel } from '../../../../Monitor/Shared/models/monitoring-back-end-data-source.model';
import { MonitoringSeriesTypeEnum } from '../../../../Monitor/Shared/enums/monitoring-series-type.enum';
import { MentionSearchQueryModel } from '../../../../Monitor/Shared/models/mention-search-query.model';
import { TabsOrientationsEnum } from '@Common/Layout/components/Tabs/tabs.component';
import { ReportSeriesModel } from '@Common/Reports/models/report-series.model';
import { ChartDisplayElementModel } from '@Common/Reports/models/chart-display-element.model';
import { SocialSeriesMetricsEnum } from '@Social/Intelligence/enums/social-series-metrics.enum';
import { CardChartComponentHighlightColorEnum } from '@Common/Charts/components/CardChart/card-chart.component';
import { SocialSeriesNeoFacetKeysEnum } from '@Social/Intelligence/enums/social-series-neo-facet-keys.enum';
import { DataPointModel } from '@Common/Charts/models/data-point.model';
import { SearchCriteriaQuerySentimentsEnum } from '@api/mentions/enum/search-criteria-query-sentiments.enum';
import { AggregateDateFacetTypesEnum } from '@api/mentions/enum/aggregate-date-facet-types.enum';
import { DateFacetTypesEnum } from '@api/mentions/enum/date-facet-types.enum';
import { ReportsDashboardSearchService } from '@Common/Reports/services/reports-dashboard-search.service';
import { MonitoringRoutingService } from '@Monitor/Core/services/monitoring-routing.service';
import { getMonitoringDateQueryInputFolderOptions,
    getMonitoringDateQueryInputTopicOptions
} from '../../../../Monitor/Shared/models/monitoring-date-query-input-options';
import { SocialRoutingService } from '@Social/Core/services/social-routing.service';
import { DuplicatesStatusEnum } from '@Common/Filter/enums/duplicates-status.enum';
import { BucketFunctionApiEnum } from '@api/mentions/enum/bucket-function-api.enum';
import { NeoFacetTermFieldApiEnum } from '@api/mentions/enum/neo-facet-term-field-api.enum';
import { NeoFacetRequestApiModel } from '@api/mentions/model/neo-facet-request-api.model';
import { FilterService } from '@Common/Filter/services/abstract-filter.service';
import { SocialChartDetailsDialogService } from '@Social/Intelligence/services/social-chart-details-dialog.service';
import { MediaTypeEnum } from '@Common/Basic/enums/media-type.enum';
import { ChartLoadingOptionsEnum } from '@Common/Charts/enums/chart-loading-options.enum';
import { ReportDateRangeModel } from '@Common/Reports/models/report-date-range.model';
import { ComparisonHelper } from '@Monitor/Shared/helpers/comparison/comparison.helper';
import { ConfigService } from '../../../../Core/Config/services/config.service';
import { SearchStatesEnum } from '../../../../Monitor/Shared/enums/search-states.enum';
import { ReportSeriesFacetGeneratorEnum } from '@Common/Reports/models/report-series-facet-generator.enum';
import { ChartGroupInputModel } from '@Common/Charts/models/chart-group-input.model';
import { SeriesTypeEnum } from '@Common/Reports/enums/series-type.enum';
import { DateQueryDateTypeEnum } from '@api/mentions/enum/date-query-date-type.enum';
import { NeoFacetDateFieldApiEnum } from '@api/mentions/model/neo-facet-date-field-api.enum';
import { ReportsNeoFacetKeys } from '@Common/Reports/enums/reports-neo-facet-keys.enum';
import { ChartSpecificTypesEnum } from '@Common/Reports/enums/chart-specific-types.enum';
import { chartColors } from '@Common/Charts/enums/chart-colors.enum';
import { ChartStylesModel } from '@Common/Charts/models/chart-styles.model';
import { ReportsChartSeriesConverterService } from '@Common/Reports/services/reports-chart-series-converter.service';
import { ReportsSeriesDataMapperService } from '@Common/Reports/services/reports-series-data-mapper.service';
import { ChartMetricsEnum } from '@Common/Reports/enums/chart-metrics.enum';
import { CoverageInsightConfigModel } from '../../models/coverage-insight-config.model';
import { KeyMessageGroupApi } from '../../../../api/ai/model/key-message-group-api.';
import { chartsOverTimeMap } from '@Common/Reports/enums/charts-over-time.enum';
import { messageSeverityEnum } from '@Common/Misc/enums/message-severity.enum';
import { ChartDrillDownTabEnum } from '@Common/Reports/enums/chart-drill-down-tab.enum';
import { Am5Chart } from '@Common/Charts/models/am5-chart.model';
import { Am5ChartBlockComponent } from '../Am5ChartBlock/am5-chart-block.component';
import { Am5DateValueXYChart } from '@Common/Charts/models/Am5DateValueXYChart/am5-date-value-x-y-chart.model';
import { Am5ChartConfigurationService } from '@Common/Reports/services/am5-chart-configuration.service';
import { Am5ChartSettingsService } from '@Common/Reports/services/am5-chart-settings.service';
import { Am5ChartTooltipService } from '@Common/Charts/services/am5-chart-tooltip.service';
import { Am5ChartComponent } from '@Common/Charts/components/Am5Chart/am5-chart.component';
import { AgentRouteSectionEnum, agentSectionRoute } from '../../../../AutomationAgents/AutomationAgentsRouter/automation-agents-route.const';


export interface MentionCardClickedEvent {
    eventType: 'contact' | 'outlet' | 'mention';
    mention: Mention;
}

enum ChartContactOutletTabEnum {
    contactList = 0,
    outletList = 1
}

enum ChartDrillDownTabIds {
    DASHBOARD = 'chartDrillDown.dashboardTab',
    MENTION = 'chartDrillDown.mentionListTab',
    CONTACT_OUTLET = 'chartDrillDown.contactOutletListTab',
    COVERAGE_INSIGHTS = 'chartDrillDown.coverageInsightsTab',
    ACTION_ASSISTANT = 'chartDrillDown.actionAssistantTab'
}

enum ChartDrillDownTabIcons {
    DASHBOARD = 'fa-regular fa-md fa-pie-chart',
    MENTION = 'fa-kit-duotone fa-agpr-view-coverage',
    CONTACT_OUTLET = 'fa-kit-duotone fa-agpr-contacts-outlets',
    COVERAGE_INSIGHTS = 'fa-kit-duotone fa-agpr-insights',
    ACTION_ASSISTANT = 'fa-kit-duotone fa-agpr-ai-action',
    MENTION_SELECTED = 'fa-kit fa-agpr-view-coverage-solid',
    CONTACT_OUTLET_SELECTED = 'fa-kit fa-agpr-contacts-outlets-solid',
    COVERAGE_INSIGHTS_SELECTED = 'fa-kit fa-agpr-insights-solid',
    ACTION_ASSISTANT_SELECTED = 'fa-kit-duotone fa-agpr-ai-action',
}
@Component({
    selector: 'agpr-chart-drill-down-dialog',
    templateUrl: './chart-drill-down-dialog.component.html',
    styleUrls: ['./chart-drill-down-dialog.component.scss'],
    providers: [
        ReportsDashboardSearchService,
        Am5ChartTooltipService,
        {
            provide: FilterService,
            useExisting: MentionSearchService
        },
        {
            provide: MentionSearchService,
            useExisting: ReportsDashboardSearchService
        },
    ],
    standalone: false
})
export class ChartDrillDownDialogComponent extends AbstractDialogComponent implements  OnInit, AfterViewInit, OnDestroy  {

    @Input() overlayContainer: Element;
    @Input() animationTrigger: Observable<FullProfileAnimationModel>;
    @Input() block: BlockModel;
    @Input() chart: ChartModel;
    @Input() chartGroup: ChartGroupInputModel;
    @Input() am5Chart: Am5Chart;
    @Input() reportSeries: ReportSeriesModel[];
    @Input() url: string;
    @Input() baseSearch: MentionSearchCriteriaModel;
    @Input() themeId: number;
    @Input() selectedTabIndex: ChartDrillDownTabEnum = ChartDrillDownTabEnum.dashboard;
    @Input() coverageInsightConfig: CoverageInsightConfigModel;
    @Input() filterQuery: MentionSearchQueryModel;
    @Input() savedFilterIds: number[] = [];
    @Input() showSimilar: boolean = true;
    @Input() forceAccountSearch: boolean;
    @Input() baseRange: ReportDateRangeModel;
    @ViewChild('rightSidebar') public rightSidebar: RightSidebarComponent;
    @ViewChildren('am5ChartComponent') public am5ChartComponents: QueryList<Am5ChartComponent>;

    readonly buttonTypes = ButtonTypesEnum;
    readonly chartDrillDownTabEnum = ChartDrillDownTabEnum;
    readonly cardChartComponentHighlightColorEnum = CardChartComponentHighlightColorEnum;
    readonly tabsOrientationsEnum = TabsOrientationsEnum;
    readonly id = 'ChartDrillDownDialog';
    readonly entityType = EntityType;
    readonly tabIds = ChartDrillDownTabIds;
    readonly tabIcons = ChartDrillDownTabIcons;
    readonly socialMetrics = SocialSeriesMetricsEnum;
    readonly savedSources = [
        MonitoringSeriesTypeEnum.folder,
        MonitoringSeriesTypeEnum.tag,
        MonitoringSeriesTypeEnum.tagGroup,
        MonitoringSeriesTypeEnum.aiAgent,
    ];
    readonly chartLoadingOptionsEnum = ChartLoadingOptionsEnum;
    readonly scrollPreventingBlockHeight = 415;
    readonly messageSeverities = messageSeverityEnum;

    hideSlideOverlay: boolean = false;

    /** The series was pre-filled with the agent its search is scoped to, and still searches by that scope */
    private isAgentScopedSearch: boolean = false;

    mentionSearch: MentionSearchCriteriaModel;
    dateQuery: DateQueryModel;
    topicSearch: MentionSearchModel;

    dateFilterOptions$: Observable<DropdownOptionModel[]> = of(getDefaultDateInputOptionValuesModel());
    dateTypeFilterOptions$: Observable<DropdownOptionModel[]> = of(defaultDateTypeOptions);

    selectedContactOutletIndex: ChartContactOutletTabEnum = ChartContactOutletTabEnum.contactList;

    blockWidth: number;
    blockHeight: number;
    source: MonitoringBackEndDataSourceModel;
    clonedSeries: ReportSeriesModel;
    originalBlock: BlockModel;
    viewMentionsUrl: string;
    hasTargeting: boolean = false;
    initialLoadCount: number = 0;
    changingSource: boolean = false;
    useDrilldownSeries: boolean = false;
    hasInitializedSeries: boolean = false;
    sourceSelected: boolean = true;
    chartNoData: boolean = false;
    sharedKeyMessageGroups: KeyMessageGroupApi[] = null;
    isCoverageInsightActive: boolean = false;

    cardsNeoFacet: NeoFacetRequestApiModel = {
        termField: NeoFacetTermFieldApiEnum.MEDIA_TYPE,
        key: SocialSeriesNeoFacetKeysEnum.mediaTypeFacetGroup,
        aggregateBucketRequests: [
            {
                key: SocialSeriesNeoFacetKeysEnum.mediaTypeImpressions,
                field: NeoFacetTermFieldApiEnum.AUDIENCE_REACH,
                function: BucketFunctionApiEnum.INDIVIDUAL_SUM
            }
        ]
    };

    selectedMentions: Mention[] = [];

    // Card charts at the top of the page
    public totalVolumeSeries: ReportSeriesModel;
    public previousPeriodTotalVolumeSeries: ReportSeriesModel;

    public totalImpressionsSeries: ReportSeriesModel;
    public previousPeriodTotalImpressionsSeries: ReportSeriesModel;

    public totalAveSeries: ReportSeriesModel;
    public previousPeriodTotalAveSeries: ReportSeriesModel;

    public totalPositiveSeries: ReportSeriesModel;
    public previousPeriodTotalPositiveSeries: ReportSeriesModel;

    public totalNeutralSeries: ReportSeriesModel;
    public previousPeriodTotalNeutralSeries: ReportSeriesModel;

    public totalNegativeSeries: ReportSeriesModel;
    public previousPeriodTotalNegativeSeries: ReportSeriesModel;

    public defaultVolumeSeries: ReportSeriesModel;

    drilldownSeries: ReportSeriesModel;
    am5Charts: { [key: string]: Am5Chart } = {};

    seriesChartProvider: Subscription;
    isRefMediaAccount: boolean = false;

    ignoreSourceChange: boolean = false;
    firstTimeLoading: boolean = true;
    tempSearchCriteriaModel: MentionSearchCriteriaModel;
    tempFilterQuery: MentionSearchQueryModel;

    customChartLegend: ElementRef;
    @ViewChild('customChartLegend', { static: false }) set content(content: ElementRef) {
        if (content) { // initially setter gets called with undefined
            this.customChartLegend = content;
            if (this.chart?.options?.legendContainerElement && this.customChartLegend) {
                this.chart.options.legendContainerElement = this.customChartLegend.nativeElement;
                this.blockHeight = 360;
            }
        }
    }

    subscriptions: Subscription[] = [];

    constructor(
        public zone: NgZone,
        public coreDialogService: CoreDialogService,
        public pageBuilderService: ReportsPageBuilderService,
        public reportsChartDetailService: ReportsChartDetailService,
        protected targetingRhpContextsService: TargetingRhpContextsService,
        protected mentionsService: MentionsService,
        protected injector: Injector,
        protected targetingSearchService: TargetingSearchService,
        protected targetingRhpDialogService: TargetingRhpDialogService,
        protected currentUserStateService: CurrentUserStateService,
        protected topicsService: TopicsService,
        private reportsDashboardSearchService: ReportsDashboardSearchService,
        private monitoringRoutingService: MonitoringRoutingService,
        private socialRoutingService: SocialRoutingService,
        public socialChartDetailsDialogService: SocialChartDetailsDialogService,
        public reportsChartSeriesConverterService: ReportsChartSeriesConverterService,
        public reportsSeriesDataMapperService: ReportsSeriesDataMapperService,
        public configService: ConfigService,
        public am5ChartConfigurationService: Am5ChartConfigurationService,
        public am5ChartSettingsService: Am5ChartSettingsService,
        public am5ChartTooltipService: Am5ChartTooltipService
    ) {
        super(coreDialogService, 'ChartDrillDownDialog');

        this.subscriptions.push(
            this.currentUserStateService.getPermissions().subscribe(permissions => {
                if (permissions) {
                    this.hasTargeting = permissions.includes(userPermissionsEnum.advancedTargeting);
                }
            }),
            this.reportsDashboardSearchService.getSearchCriteria().subscribe(search => {
                if (!search) {
                    return;
                }
                if (search.equals(new MentionSearchCriteriaModel())) {
                    return;
                }
                if (search.equals(this.mentionSearch)) {
                    return;
                }
                this.mentionSearch = search;
                if (this.mentionSearch.query.folder.include.length > 0) {
                    this.source = new MonitoringBackEndDataSourceModel(
                        MonitoringSeriesTypeEnum.folder,
                        this.mentionSearch.query.folder.include[0]
                    );
                } else if (this.mentionSearch.query.tag.include.length > 0) {
                    this.source = new MonitoringBackEndDataSourceModel(
                        MonitoringSeriesTypeEnum.tag,
                        this.mentionSearch.query.tag.include[0]
                    );
                } else if (this.mentionSearch.query.tagGroup.include.length > 0) {
                    this.source = new MonitoringBackEndDataSourceModel(
                        MonitoringSeriesTypeEnum.tagGroup,
                        this.mentionSearch.query.tagGroup.include[0]
                    );
                } else if (this.mentionSearch.query.aiAgent?.include?.length > 0) {
                    this.source = new MonitoringBackEndDataSourceModel(
                        MonitoringSeriesTypeEnum.aiAgent,
                        this.mentionSearch.query.aiAgent.include[0]
                    );
                } else {
                    this.source = null;
                }
                if (this.source) {
                    this.source.filterSearchCriteria = this.mentionSearch;
                }
            }),
            this.reportsDashboardSearchService.getDateQuery().subscribe(dateQuery => this.dateQuery = dateQuery),
            this.topicsService.getFocusedTopic().pipe(filter(x => !!x)).subscribe(
                topic => {
                    if (!topic) {
                        return;
                    }

                    this.topicSearch = topic;
                }
            ),
            this.reportsDashboardSearchService.getMentions().subscribe(
                mentions => {
                    this.mentionsService.setMentions(mentions);
                    if (mentions && mentions.length) {
                        this.mentionsService.setFocusedMention(mentions[0]);
                    }
                }
            ),
            this.reportsDashboardSearchService.getMentionCount().subscribe(
                count => {
                    this.mentionsService.setMentionsCount(count);
                }
            ),
            this.reportsDashboardSearchService.getSearchState().subscribe(state => {
                if (state.type === SearchStatesEnum.success) {
                    this.ignoreSourceChange = false;
                    if (this.firstTimeLoading) {
                        this.firstTimeLoading = false;
                        this.makeCallsAfterBaseRequest(this.tempSearchCriteriaModel, this.tempFilterQuery);
                    }
                    this.initializeAll();
                }
            })
        );

        this.isRefMediaAccount = this.configService.brandGUIDIsRefMedia();
    }

    @HostListener('document:click', ['$event.target']) onClick(event) {
        if (event?.classList?.contains('viewMentionLink')) {
            this.url = event.href;

            this.ignoreSourceChange = true;
            this.clonedSeries = null;
            this.handleUrl();
            return false;
        }
    }

    /**
     * Whether a re-search runs from the criteria rather than from the series' source. True for an
     * archive search, and for any drill down whose series carries no source to query by.
     */
    private get searchesByQuery(): boolean {
        const isArchiveSearch = !!this.baseSearch
            && this.baseSearch.query.agent.include.length === 0
            && this.baseSearch.query.theme.include.length === 0;

        return isArchiveSearch || this.isAgentScopedSearch || !this.drilldownSeries?.getSeriesSourceId();
    }

    /**
     * A series with no source of its own whose search is scoped to one automation agent - an agent's
     * analytics - shows that agent in the source picker. The search itself stays the scoped one (see
     * {@link isAgentScopedSearch}), so the sources and ad hoc runs ticked in the agent's sidebar
     * still narrow it.
     */
    private prefillAgentSource(series: ReportSeriesModel): void {
        if (series.getSeriesSourceId()) {
            return;
        }

        const agentIds = this.baseSearch?.query?.aiAgent?.include
            ?? series.mentions.combinedQuery?.aiAgent?.include;

        if (agentIds?.length !== 1) {
            return;
        }

        series.type = SeriesTypeEnum.aiAgent;
        series.mentions.aiAgentId = agentIds[0];
        this.isAgentScopedSearch = true;
    }

    ngOnInit(): void {
        if (this.block) {
            this.originalBlock = this.block.clone();
            this.chart = this.pageBuilderService.getChartComponentFromBlock(this.block)?.chart;
            this.am5Chart = (this.pageBuilderService.getChartComponentFromBlock(this.block) as Am5ChartBlockComponent)?.am5Chart;

            this.setBlockSize();
        } else if (this.chart || this.am5Chart) {
            this.setChartDimensions();
        } else if (this.chartGroup) {
            this.setChartDimensions();
            this.blockHeight = 380;
        }
        this.setAm5Charts(this.am5Chart);

        this.reportsDashboardSearchService.setSearchCriteria(null);
        this.reportsDashboardSearchService.clearSearch();
        this.handleUrl();
    }

    ngAfterViewInit(): void {
        requestAnimationFrame(() => {
            this.am5ChartComponents.forEach(component => {
                component.setChartAnnotations();
            });
        });
    }

    setAm5Charts(am5Chart: Am5Chart): void {
        if (!am5Chart) {
            return;
        }
        am5Chart.series = am5Chart.series.filter(x => !x.indicatorTargetIndex && x.indicatorTargetIndex !== 0);
        this.am5Charts[ChartDrillDownTabEnum.dashboard] = am5Chart.clone();
        this.am5Charts[ChartDrillDownTabEnum.mentionList] = am5Chart.clone();
        if (this.hasTargeting) {
            this.am5Charts[ChartDrillDownTabEnum.contactOutletList] = am5Chart.clone();
        }
    }

    drillDownAm5Chart(event: any) {
        const url = event.data;
        this.url = url;
        if (url) {
            this.ignoreSourceChange = true;
        }
        this.clonedSeries = null;
        this.handleUrl();
    }

    handleUrl() {
        if (this.url) {
            const filterString = this.url.split('filters=')?.[1];
            const model = MentionSearchCriteriaModel.fromFilterQueryString(filterString);

            // charts
            let series: ReportSeriesModel;
            if (this.chart) {
                series = (this.chart.series as ReportSeriesModel[]).find(x => x.seriesUniqueUuid === model.seriesUniqueUuid);
            } else if (this.chartGroup) {
                this.chartGroup.charts.forEach(chart => {
                    if ((chart.series as ReportSeriesModel[]).find(x => x.seriesUniqueUuid === model.seriesUniqueUuid)) {
                        series = (chart.series as ReportSeriesModel[]).find(x => x.seriesUniqueUuid === model.seriesUniqueUuid);
                    }
                });
            } else if (this.am5Chart) {
                series = (this.useDrilldownSeries ? [this.drilldownSeries] : this.reportSeries)
                    .find(x => x.seriesUniqueUuid === model.seriesUniqueUuid);
            } else {
                series = (this.block.displayElement as ChartDisplayElementModel).series.find(x => x.seriesUniqueUuid === model.seriesUniqueUuid);
            }

            if (series) {
                if (this.baseRange) {
                    series.mentions.baseDateRange = this.baseRange;
                } else {
                    series.mentions.baseDateRange = series.dateRange;
                }

                if (this.themeId) {
                    series.type = SeriesTypeEnum.theme;
                    this.reportsDashboardSearchService.resetFilters(SeriesTypeEnum.theme);
                    this.reportsDashboardSearchService.clearFilters();
                    series.mentions.themeId = this.themeId;
                    this.reportsDashboardSearchService.setAgentFilterOptions(this.themeId);
                }

                if (!this.themeId && series.mentions.themeId) {
                    this.reportsDashboardSearchService.resetFilters(SeriesTypeEnum.theme);
                    this.reportsDashboardSearchService.clearFilters();
                    this.reportsDashboardSearchService.setAgentFilterOptions(series.mentions.themeId);
                }

                if (this.baseSearch) {
                    series.mentions.combinedQuery = this.baseSearch.query;
                    series.mentions.useCombinedQuery = true;
                }

                // we have to set drilldownSeries after we modify it because of the ngModel for the source picker;
                // the copy is the one modified, though - the series still belongs to the chart behind the
                // dialog, and switching off appendCombineQuery there would stop that chart's later
                // searches updating its combined query, so every later drill down would get a stale one
                const drilldownSeries = series.clone();
                this.prefillAgentSource(drilldownSeries);
                drilldownSeries.appendCombineQuery = false;
                this.drilldownSeries = drilldownSeries;
                this.reportsDashboardSearchService.setSourceSeries(this.drilldownSeries as ReportSeriesModel);
                this.getInfoFromUrl(model);
                this.watchSeriesDataProvider();
            }
        }
    }

    getInfoFromUrl(model: {search: MentionSearchCriteriaModel; seriesUniqueUuid: string; savedFilterIds: number[]}) {
        this.firstTimeLoading = true;
        let searchCriteriaModel = new MentionSearchCriteriaModel();
        searchCriteriaModel.query = this.drilldownSeries?.mentions.combinedQuery?.clone() || this.baseSearch?.query;

        // this check is for MAD Coverage Insights & Social.. every other scenario we want to use the date from the url search..
        // but because here we use a button to open the drilldown that is outside of the chart..
        // we can check to see if it's equal to 24 hrs (the default), and if it is, to use baseRange
        const combineQuery = this.drilldownSeries?.mentions.combinedQuery?.clone();
        const twentyFourHours = DateQueryModel.getLast24HoursQuery();
        twentyFourHours.dateType = DateQueryDateTypeEnum.PUBLISHED;

        const isDefaultDateQuery = new ReportDateRangeModel().setFromDateQuery(model.search.query?.dateQuery || new DateQueryModel()).isEqual(
            new ReportDateRangeModel().setFromDateQuery(twentyFourHours)
        );

        let isFilterDefaultDateQuery: boolean = true;
        if (model.search.filterQuery?.dateQuery) {
            isFilterDefaultDateQuery = new ReportDateRangeModel().setFromDateQuery(model.search.filterQuery?.dateQuery).isEqual(
                new ReportDateRangeModel().setFromDateQuery(twentyFourHours)
            );
        }
        let dateQuery = !isFilterDefaultDateQuery ? model.search.filterQuery?.dateQuery :
            (this.baseRange && isDefaultDateQuery ? this.baseRange : model.search.query?.dateQuery);


        // some charts from MAD default to 24 hours, even though it's not, so we can do this check to see
        // if the date is set to the default 24 hours, and the filter query is not 24hrs, to change it
        if (this.filterQuery?.dateQuery) {
            const isDefault24HrDate= new ReportDateRangeModel().setFromDateQuery(dateQuery).isEqual(
                new ReportDateRangeModel().setFromDateQuery(twentyFourHours)
            );
            const isFilter24HrDate= new ReportDateRangeModel().setFromDateQuery(this.filterQuery?.dateQuery).isEqual(
                new ReportDateRangeModel().setFromDateQuery(twentyFourHours)
            );
            if (isDefault24HrDate && !isFilter24HrDate) {
                dateQuery = this.filterQuery?.dateQuery;
            }
        }

        // all over time charts, we want to set the date query to the drilldown time
        if (chartsOverTimeMap.includes(this.drilldownSeries._chartType)) {
            delete this.drilldownSeries.mentions.baseDateRange;
        }

        const comparisonHelper = new ComparisonHelper();
        let filterQuery: MentionSearchQueryModel;
        if (!this.baseSearch) {
            if (!comparisonHelper.compareObjectsArraysForEquality(combineQuery.includedMediaTypes, model.search.query.includedMediaTypes, 'id')) {
                combineQuery.includedMediaTypes = [];
            }

            if (combineQuery.includedMediaTypes?.length === Object.keys(MediaTypeEnum).length) {
                combineQuery.includedMediaTypes = [];
            }

            if (!comparisonHelper.compareObjectsArraysForEquality(combineQuery.sentiments, model.search.query.sentiments, 'id')) {
                combineQuery.sentiments = [];
            }
            if (combineQuery.sentiments?.length === Object.keys(SearchCriteriaQuerySentimentsEnum).length) {
                combineQuery.sentiments = [];
            }

            const difference = model.search.query.differenceInQueries(combineQuery);

            if (this.drilldownSeries?.mentions?.filters?.searchCriteria?.query) {
                filterQuery = MentionSearchQueryModel.createFiltered(difference, this.drilldownSeries?.mentions?.filters?.searchCriteria?.query);
            } else {
                filterQuery = difference;
            }
        } else {
            filterQuery = model.search.filterQuery;
            if (this.themeId && this.baseSearch.query.agent.include.length) {
                filterQuery.agent.include = this.baseSearch.query.agent.include;
            }
        }

        if (!searchCriteriaModel) {
            searchCriteriaModel = new MentionSearchCriteriaModel();
        }

        this.viewMentionsUrl = this.url;
        let route: any = this.monitoringRoutingService.getRouteModel(this.url);

        let id: number, dateFilterOptions: DropdownOptionModel[], dateTypeFilterOptions: DropdownOptionModel[];
        // monitor route
        if (route) {
            id = +route.value;
            if (id) {
                switch (route.type) {
                    case RouteType.folder:
                        searchCriteriaModel.isAccountSearch = true;
                        searchCriteriaModel.query.folder.include = [id];
                        dateFilterOptions = getMonitoringDateQueryInputFolderOptions();
                        dateTypeFilterOptions = savedSourceDateTypeOptions;
                        break;
                    case RouteType.topic:
                        if (this.drilldownSeries?.mentions?.topic?.searchCriteria) {
                            searchCriteriaModel = this.drilldownSeries?.mentions?.topic?.searchCriteria;
                        }
                        searchCriteriaModel.isAccountSearch = false;
                        dateFilterOptions = getMonitoringDateQueryInputTopicOptions();
                        dateTypeFilterOptions = defaultDateTypeOptions;
                        break;
                    case RouteType.subscriptionResults:
                    case RouteType.subscription:
                        searchCriteriaModel.isAccountSearch = false;
                        searchCriteriaModel.query.subscription.include = [id];
                        dateFilterOptions = getMonitoringDateQueryInputTopicOptions();
                        dateTypeFilterOptions = defaultDateTypeOptions;
                        break;
                    default:
                        searchCriteriaModel.isAccountSearch = true;
                        dateFilterOptions = getMonitoringDateQueryInputFolderOptions();
                        dateTypeFilterOptions = savedSourceDateTypeOptions;
                        break;
                }
            } else {
                // tag & tag groups don't have an ID in the route.. and we check if there is an ID for MAD (coming from a new search)
                if (this.isSavedSource()) {
                    searchCriteriaModel.isAccountSearch = true;
                    dateFilterOptions = getMonitoringDateQueryInputFolderOptions();
                    dateTypeFilterOptions = savedSourceDateTypeOptions;
                }
            }
        } else {
            // means it's a social route
            route = this.socialRoutingService.getRouteModel(this.url);

            searchCriteriaModel.isAccountSearch = false;
            dateFilterOptions = getMonitoringDateQueryInputTopicOptions();
            dateTypeFilterOptions = defaultDateTypeOptions;
        }

        if (!route && this.isSavedSource() || this.forceAccountSearch) {
            searchCriteriaModel.isAccountSearch = true;
        }

        if (this.filterQuery) {
            filterQuery = MentionSearchQueryModel.createFiltered(filterQuery, this.filterQuery);
        }

        filterQuery = this.moveAgentScopeToFilters(searchCriteriaModel.query, filterQuery);

        if (filterQuery.sentiments?.length === Object.keys(SearchCriteriaQuerySentimentsEnum).length) {
            filterQuery.sentiments = [];
        }

        this.dateFilterOptions$ = of(dateFilterOptions);
        this.dateTypeFilterOptions$ = of(dateTypeFilterOptions);

        this.reportsDashboardSearchService.setDateQuery(dateQuery);
        this.setDateQueryOnSearchCriteria(dateQuery, searchCriteriaModel);

        this.reportsDashboardSearchService.clearSearch();

        // set search criteria without filters for the facets/filters
        searchCriteriaModel.filterQuery = null;

        if (this.drilldownSeries.mentions.themeId) {
            this.themeId = this.drilldownSeries.mentions.themeId;
            searchCriteriaModel.query.agent.include = [];
        }
        if (this.themeId && !searchCriteriaModel.query.agent.include?.length) {
            searchCriteriaModel.query.theme.include = [this.themeId];
        }
        // this is the "base request", which is only to set the base filters
        // but we need to return before setting the chip filters before the
        // in the search call, we set the setFilteredFacets which set the options of the filters
        // and therefore would not set properly in some scenarios
        this.reportsDashboardSearchService.setSearchCriteria(searchCriteriaModel);
        this.reportsDashboardSearchService.resetFilters(this.drilldownSeries.type);
        this.reportsDashboardSearchService.duplicates.setValue(searchCriteriaModel.showSimilar ? DuplicatesStatusEnum.show : DuplicatesStatusEnum.hide);

        this.reportsDashboardSearchService.search(true, true);

        // we want to set these temp values to be used after the initial base request
        searchCriteriaModel.savedFilterIds = model.savedFilterIds;
        this.tempSearchCriteriaModel = searchCriteriaModel;
        this.tempFilterQuery = filterQuery;
    }

    // setting the filter chips after the initial base search
    makeCallsAfterBaseRequest(searchCriteriaModel, filterQuery) {
        if (searchCriteriaModel.savedFilterIds || this.savedFilterIds?.length) {
            const savedFilterIds = [...searchCriteriaModel.savedFilterIds || [], ...this.savedFilterIds || []];
            this.reportsDashboardSearchService.setSavedFiltersFromIds(savedFilterIds);
        }
        this.reportsDashboardSearchService.setSearchCriteria(searchCriteriaModel);
        if (filterQuery) {
            this.reportsDashboardSearchService.populateFiltersFromSearchQuery(filterQuery, false, true);
        }

        if (!this.showSimilar) {
            this.reportsDashboardSearchService.duplicates.setValue(DuplicatesStatusEnum.hide);
        }

        this.reportsDashboardSearchService.applyFilters(false);
        this.reportsDashboardSearchService.search(false, false);
        this.doContactOutletSearches();
    }

    reGetMentions(series: ReportSeriesModel, clearFilters: boolean = true): void {
        const searchCriteriaModel = new MentionSearchCriteriaModel();
        let dateFilterOptions: DropdownOptionModel[], dateTypeFilterOptions: DropdownOptionModel[];

        dateTypeFilterOptions = defaultDateTypeOptions;

        if (series?.mentions) {
            this.sourceSelected = true;
            if (series.mentions.folderId) {
                searchCriteriaModel.isAccountSearch = true;
                searchCriteriaModel.query.folder.include = [series.mentions.folderId];
                dateFilterOptions = getMonitoringDateQueryInputFolderOptions();
                dateTypeFilterOptions = savedSourceDateTypeOptions;
            } else if (series.mentions.mediaSubscriptionId) {
                searchCriteriaModel.isAccountSearch = false;
                searchCriteriaModel.query.subscription.include = [series.mentions.mediaSubscriptionId];
                dateFilterOptions = getMonitoringDateQueryInputTopicOptions();
                dateTypeFilterOptions = defaultDateTypeOptions;
            } else if (series.mentions.tagId) {
                searchCriteriaModel.isAccountSearch = true;
                searchCriteriaModel.query.tag.include = [series.mentions.tagId];
                dateFilterOptions = getMonitoringDateQueryInputTopicOptions();
                dateTypeFilterOptions = defaultDateTypeOptions;
            } else if (series.mentions.tagGroupId) {
                searchCriteriaModel.isAccountSearch = true;
                searchCriteriaModel.query.tagGroup.include = [series.mentions.tagGroupId];
                dateFilterOptions = getMonitoringDateQueryInputTopicOptions();
                dateTypeFilterOptions = defaultDateTypeOptions;
            }  else if (series.mentions.sourceGroupId) {
                searchCriteriaModel.isAccountSearch = true;
                searchCriteriaModel.query.sourceGroup.include = [series.mentions.sourceGroupId];
                dateFilterOptions = getMonitoringDateQueryInputTopicOptions();
                dateTypeFilterOptions = defaultDateTypeOptions;
            } else if (series.mentions.aiAgentId) {
                searchCriteriaModel.isAccountSearch = true;
                searchCriteriaModel.query.aiAgent = { include: [series.mentions.aiAgentId], exclude: [] };
                dateFilterOptions = getMonitoringDateQueryInputFolderOptions();
                dateTypeFilterOptions = savedSourceDateTypeOptions;
            } else if (series.mentions.topicId) {
                searchCriteriaModel.isAccountSearch = false;
                dateFilterOptions = getMonitoringDateQueryInputTopicOptions();
                dateTypeFilterOptions = defaultDateTypeOptions;
                if (series?.mentions.topic?.searchCriteria?.query) {
                    searchCriteriaModel.query = series?.mentions.topic?.searchCriteria?.query;
                } else {
                    searchCriteriaModel.query = series?.fullSearch?.query;
                }
            } else if (series.mentions.themeId) {
                searchCriteriaModel.isAccountSearch = false;
                dateFilterOptions = getMonitoringDateQueryInputTopicOptions();
                searchCriteriaModel.query.theme.include = [series.mentions.themeId];
                this.reportsDashboardSearchService.setAgentFilterOptions(series.mentions.themeId);
            } else if (series.mentions.socialTopicId) {
                searchCriteriaModel.isAccountSearch = false;
                dateFilterOptions = getMonitoringDateQueryInputTopicOptions();
                searchCriteriaModel.query.agent.include = [series.mentions.socialTopicId];
            } else {
                // no source selected
                console.log('no source selected');
                this.tempFilterQuery = null;
                this.drilldownSeries.dataProvider.next([]);
                this.reportsDashboardSearchService.setSearchCriteria(new MentionSearchCriteriaModel());
                this.reportsDashboardSearchService.clearSearch();
                this.reportsDashboardSearchService.clearFilters();
                this.reportsDashboardSearchService.applyFilters(false);
                this.reportsDashboardSearchService.setBlankData();
                this.targetingSearchService.clearSearch();
                this.changingSource = false;
                this.sourceSelected = false;
                return;
            }
        }

        this.dateFilterOptions$ = of(dateFilterOptions);
        this.dateTypeFilterOptions$ = of(dateTypeFilterOptions);

        this.reportsDashboardSearchService.clearSearch(clearFilters);
        if (clearFilters) {
            this.tempFilterQuery = null;
            this.reportsDashboardSearchService.clearFilters();
        }
        searchCriteriaModel.showSimilar = clearFilters ? true : this.reportsDashboardSearchService.duplicates.getValue() !== DuplicatesStatusEnum.hide;
        this.reportsDashboardSearchService.setSearchCriteria(searchCriteriaModel);

        if (this.dateQuery) {
            this.reportsDashboardSearchService.setDateQuery(this.dateQuery);
            this.setDateQueryOnSearchCriteria(this.dateQuery, searchCriteriaModel);
            if (!this.drilldownSeries.isValid()) {
                series.dateRange = new ReportDateRangeModel().setFromDateQuery(this.dateQuery);
            }
        }
        this.drilldownSeries.mentions.combinedQuery = searchCriteriaModel.query;

        this.reportsDashboardSearchService.resetFilters(this.drilldownSeries.type);
        this.reportsDashboardSearchService.applyFilters();
        this.reportsDashboardSearchService.duplicates.setValue(searchCriteriaModel.showSimilar ? DuplicatesStatusEnum.show : DuplicatesStatusEnum.hide);
        this.reportsDashboardSearchService.search(true, true);
    }

    sourceChanged(series: ReportSeriesModel) {
        if (!this.clonedSeries && this.defaultVolumeSeries) {
            this.clonedSeries = this.defaultVolumeSeries?.clone();
        }
        if (!this.changingSource && !this.ignoreSourceChange && this.defaultVolumeSeries && !this.defaultVolumeSeries.isEqual(this.clonedSeries)) {
            this.changingSource = true;
            this.isAgentScopedSearch = false;
            series.mentions.filters = null;
            this.baseSearch = null;
            this.reGetMentions(series);
            if (this.sourceSelected) {
                this.reportsDashboardSearchService.deregisterSeries([this.drilldownSeries]);

                series.dateRange = new ReportDateRangeModel().setFromDateQuery(this.dateQuery);
                series.mentions.baseDateRange = new ReportDateRangeModel().setFromDateQuery(this.dateQuery);
                const dataMapper = this.defaultVolumeSeries.mentions.dataMapper;
                const facetGenerator = this.defaultVolumeSeries.mentions.facetGenerator;
                this.defaultVolumeSeries.mentions = series.mentions;
                this.defaultVolumeSeries.type = series.type;
                this.defaultVolumeSeries.mentions.dataMapper = dataMapper;
                this.defaultVolumeSeries.mentions.facetGenerator = facetGenerator;

                this.clonedSeries = this.defaultVolumeSeries.clone();
                this.drilldownSeries = this.defaultVolumeSeries;
                this.reportsDashboardSearchService.setSourceSeries(this.drilldownSeries as ReportSeriesModel);

                const summaryTrendLineStyles = new ChartStylesModel();
                summaryTrendLineStyles.colorMap = {
                    'analysisColor1': chartColors.agprBlue
                };

                this.chart?.destroy();
                this.chart = null;
                this.block = null;
                const hasChartGroup = this.chartGroup?.charts?.length > 0;
                if (hasChartGroup) {
                    this.chartGroup.charts.forEach(chart => chart?.destroy());
                    this.chartGroup = null;
                }
                Object.values(this.am5Charts)?.forEach(chart => {
                    chart?.destroy();
                    chart = null;
                });

                const chartSeries = this.reportsChartSeriesConverterService.getDateValueChartSeries(
                    [this.drilldownSeries], ReportBlockTypeEnum.COVERAGE_OVER_TIME, ChartSpecificTypesEnum.LINE, ''
                );
                const chartDisplayElement = new ChartDisplayElementModel('', [this.drilldownSeries], new ChartStylesModel());
                chartDisplayElement.chartSpecificType = ChartSpecificTypesEnum.LINE;
                const chartConfiguration = this.am5ChartConfigurationService.getChartConfiguration(this.id, ReportBlockTypeEnum.COVERAGE_OVER_TIME);
                chartConfiguration.noContent.isMessageStyle = true;
                const chartSettings = this.am5ChartSettingsService.getChartSettings(
                    ReportBlockTypeEnum.COVERAGE_OVER_TIME,
                    chartDisplayElement
                );
                chartSeries.forEach((x, i) => {
                    x.tooltipHTML = this.am5ChartTooltipService.getChartTooltip([x], chartConfiguration, chartSettings, i, false);
                });
                const am5Chart = new Am5DateValueXYChart(
                    chartSeries,
                    chartConfiguration,
                    chartSettings
                );
                this.setAm5Charts(am5Chart as Am5Chart);
                this.useDrilldownSeries = true;

                this.watchSeriesDataProvider();

                this.doContactOutletSearches();
            } else {
                this.chart?.destroy();
                this.chart = null;
                this.block = null;
                this.chartGroup = null;

                Object.values(this.am5Charts).forEach(chart => {
                    chart?.destroy();
                    chart = null;
                });
            }
        }
    }

    watchSeriesDataProvider() {
        if (this.seriesChartProvider) {
            this.seriesChartProvider.unsubscribe();
            this.seriesChartProvider = null;
        }
        // HACK: I need to set the chart AFTER the return of the data, because for some reason if I don't wait, the date axis is not visible
        this.seriesChartProvider = this.drilldownSeries.dataProvider.pipe(filter(v => !!v)).subscribe((data) => {
            this.changingSource = false;
        });
    }

    filtersApplied() {
        if (this.sourceSelected) {
            this.doContactOutletSearches();
        }
    }

    dateChanged(dateQuery: DateQueryModel) {
        this.watchSeriesDataProvider();
        if (dateQuery && !DateQueryModel.equals(this.dateQuery, dateQuery)) {
            this.changingSource = true;
            this.reportsDashboardSearchService.setDateQuery(dateQuery);
            this.drilldownSeries.dateRange = new ReportDateRangeModel().setFromDateQuery(this.dateQuery);
            this.drilldownSeries.mentions.baseDateRange = new ReportDateRangeModel().setFromDateQuery(this.dateQuery);
            this.setSeriesOnChart();
            // if is a archive search, re-query with different date range
            //
            // A drill down with no source of its own - an agent's analytics, whose scope is the
            // aiAgent filter rather than a topic or folder - goes the same way: re-getting mentions
            // keys off the series' source id, which it does not have, so it would come back empty.
            if (this.searchesByQuery) {
                if (this.dateQuery) {
                    this.reportsDashboardSearchService.setDateQuery(this.dateQuery);
                    this.setDateQueryOnSearchCriteria(this.dateQuery, this.mentionSearch);
                }
                this.reportsDashboardSearchService.resetFilters(this.drilldownSeries.type);
                this.reportsDashboardSearchService.applyFilters();
                this.reportsDashboardSearchService.search(true, true);
            } else {
                this.reGetMentions(this.drilldownSeries, false);
            }
            if (this.sourceSelected) {
                this.doContactOutletSearches();
            }
        } else {
            this.changingSource = false;
        }
    }

    // because we do chart[0].series.clone().. and the HTML is usring the chart..
    // after a date change, we modify the series, we have to re-apply th newe series to the chart, because the original
    // chart "series" is still the same value as the original clone
    setSeriesOnChart() {
        if (this.chart) {
            const index = (this.chart.series as ReportSeriesModel[]).findIndex(x => x.seriesUniqueUuid === this.drilldownSeries.seriesUniqueUuid);
            if (index > -1) {
                this.chart.series[index] = this.drilldownSeries;
            }
        } else if (this.chartGroup) {
            // eslint-disable-next-line max-len
            this.chartGroup.charts.forEach(chart => {
                const index = (chart.series as ReportSeriesModel[]).findIndex(x => x.seriesUniqueUuid === this.drilldownSeries.seriesUniqueUuid);
                if (index > -1) {
                    chart.series[index] = this.drilldownSeries;
                }
            });
        } else if (this.block) {
            // eslint-disable-next-line max-len
            const index = (this.block.displayElement as ChartDisplayElementModel).series.findIndex(x => x.seriesUniqueUuid === this.drilldownSeries.seriesUniqueUuid);
            if (index > -1) {
                (this.block.displayElement as ChartDisplayElementModel).series[index] = this.drilldownSeries;
            }
        } else if (this.am5Chart) {
            const index = this.reportSeries.findIndex(x => x.seriesUniqueUuid === this.drilldownSeries.seriesUniqueUuid);
            if (index > -1) {
                this.reportSeries[index] = this.drilldownSeries;
                Object.entries(this.am5Charts).forEach(([key, chart]) => {
                    if (chart) {
                        chart.destroy();
                        this.am5Charts[key] = chart.clone();
                    }
                });
            }
        }
    }

    clearSeriesData(oldBlock: BlockModel, newBlock: BlockModel) {
        if (newBlock) {
            const displayElement = newBlock.displayElement as ChartDisplayElementModel;

            displayElement.series.forEach(_series => {
                // BehaviorSubject is used for dataProvider
                // so here clear series data so that old data would not be emitted to chart when updating chart
                _series.clearData();
            });

            // need to replace to make it handle the resize correctly
            this.pageBuilderService.replaceBlock(oldBlock, newBlock);
        }
    }

    public initializeCards(): void {
        this.defaultVolumeSeries = new ReportSeriesModel();
        this.defaultVolumeSeries.label = 'test';
        this.defaultVolumeSeries.metrics = [ChartMetricsEnum.volumeOfMentions];
        this.defaultVolumeSeries.mentions.facetGenerator = () => {
            return {
                facet: {
                    dateField: NeoFacetDateFieldApiEnum.CREATED_AT,
                    key: ReportsNeoFacetKeys.overtimeFacet,
                    aggregateBucketRequests: []
                },
                identifier: ReportSeriesFacetGeneratorEnum.neoFacet
            };
        };
        this.defaultVolumeSeries.mentions.dataMapper = (response, request, series) => {
            return this.reportsSeriesDataMapperService.mapDateDataFromNeoFacet(response, series);
        };


        // total volume series setup
        this.totalVolumeSeries = new ReportSeriesModel();
        this.totalVolumeSeries.label = 'Reports.analysis.type.volume';
        this.totalVolumeSeries.mentions.facetGenerator = () => {
            return {
                facet: this.cardsNeoFacet,
                identifier: ReportSeriesFacetGeneratorEnum.neoFacet
            };
        };
        this.totalVolumeSeries.mentions.dataMapper = (response) => {
            const neoFacet = response.neoFacetResults.find(facet => facet.key === SocialSeriesNeoFacetKeysEnum.mediaTypeFacetGroup);
            const count = neoFacet?.buckets.reduce((previousValue, bucket) => (previousValue || 0) + bucket.count, 0) || 0;
            return [{
                count: count
            }];
        };

        // previous period total volume series setup
        this.previousPeriodTotalVolumeSeries = new ReportSeriesModel();
        this.previousPeriodTotalVolumeSeries.mentions.isPreviousPeriod = true;
        this.previousPeriodTotalVolumeSeries.mentions.facetGenerator = () => {
            return {
                facet: this.cardsNeoFacet,
                identifier: ReportSeriesFacetGeneratorEnum.neoFacet
            };
        };
        this.previousPeriodTotalVolumeSeries.mentions.dataMapper = (response) => {
            const neoFacet = response.neoFacetResults.find(facet => facet.key === SocialSeriesNeoFacetKeysEnum.mediaTypeFacetGroup);
            const count = neoFacet?.buckets.reduce((previousValue, bucket) => (previousValue || 0) + bucket.count, 0) || 0;
            return [{
                count: count
            }];
        };

        // total impressions series setup
        this.totalImpressionsSeries = new ReportSeriesModel();
        this.totalImpressionsSeries.label = 'Reports.analysis.type.audienceReach';
        this.totalImpressionsSeries.mentions.facetGenerator = () => {
            return {
                facet: this.cardsNeoFacet,
                identifier: ReportSeriesFacetGeneratorEnum.neoFacet
            };
        };
        this.totalImpressionsSeries.mentions.dataMapper = (response) => {
            const neoFacet = response.neoFacetResults.find(facet => facet.key === SocialSeriesNeoFacetKeysEnum.mediaTypeFacetGroup);
            const count = neoFacet?.buckets.reduce(
                (previousValue, bucket) =>
                    (previousValue || 0) + bucket.buckets[SocialSeriesNeoFacetKeysEnum.mediaTypeImpressions][0].count
                , 0
            );

            return [{
                count: count
            }];
        };

        // previous period total volume series setup
        this.previousPeriodTotalImpressionsSeries = new ReportSeriesModel();
        this.previousPeriodTotalImpressionsSeries.mentions.isPreviousPeriod = true;
        this.previousPeriodTotalImpressionsSeries.mentions.facetGenerator = () => {
            return {
                facet: this.cardsNeoFacet,
                identifier: ReportSeriesFacetGeneratorEnum.neoFacet
            };
        };
        this.previousPeriodTotalImpressionsSeries.mentions.dataMapper = (response) => {
            const neoFacet = response.neoFacetResults.find(facet => facet.key === SocialSeriesNeoFacetKeysEnum.mediaTypeFacetGroup);
            const count = neoFacet?.buckets.reduce(
                (previousValue, bucket) =>
                    (previousValue || 0) + bucket.buckets[SocialSeriesNeoFacetKeysEnum.mediaTypeImpressions][0].count
                , 0
            );

            return [{
                count: count
            }];
        };

        // total ave series setup
        this.totalAveSeries = new ReportSeriesModel();
        this.totalAveSeries.label = 'Reports.analysis.type.ave';
        this.totalAveSeries.mentions.facetGenerator = () => {
            return {
                facet: {
                    field: DateFacetTypesEnum.created,
                    sliceSizeInSecond: 3600, // 24 hours * 60 minutes * 60 seconds
                    aggregateFacets: [
                        AggregateDateFacetTypesEnum.SUM_AD_VALUE_USD
                    ]
                },
                identifier: ReportSeriesFacetGeneratorEnum.dateFacet
            };
        };
        this.totalAveSeries.mentions.dataMapper = (response) => {
            const aveFacet = response.dateFacetResults[0];
            const count = aveFacet?.values.reduce(
                (previousValue, bucket) => (previousValue || 0) + (bucket?.aggregateFacets?.[AggregateDateFacetTypesEnum.SUM_AD_VALUE_USD] || 0),
                0
            );
            return [{
                count: count
            }];
        };

        // previous period total volume series setup
        this.previousPeriodTotalAveSeries = new ReportSeriesModel();
        this.previousPeriodTotalAveSeries.mentions.isPreviousPeriod = true;
        this.previousPeriodTotalAveSeries.mentions.facetGenerator = () => {
            return {
                facet: {
                    field: DateFacetTypesEnum.created,
                    sliceSizeInSecond: 3600, // 24 hours * 60 minutes * 60 seconds
                    aggregateFacets: [
                        AggregateDateFacetTypesEnum.SUM_AD_VALUE_USD
                    ]
                },
                identifier: ReportSeriesFacetGeneratorEnum.dateFacet
            };
        };
        this.previousPeriodTotalAveSeries.mentions.dataMapper = (response) => {
            const aveFacet = response.dateFacetResults[0];
            const count = aveFacet?.values.reduce(
                (previousValue, bucket) => (previousValue || 0) + (bucket?.aggregateFacets?.[AggregateDateFacetTypesEnum.SUM_AD_VALUE_USD] || 0),
                0
            );
            return [{
                count: count
            }];
        };


        // SENTIMENT CARDS
        this.totalPositiveSeries = new ReportSeriesModel();
        this.totalPositiveSeries.label = 'Reports.sentiment.positive';
        this.totalPositiveSeries.mentions.facetGenerator = () => {
            return {
                facet: [MentionSearchFacetTypesEnum.sentiment],
                identifier: ReportSeriesFacetGeneratorEnum.facet
            };
        };
        this.totalPositiveSeries.mentions.dataMapper = getSentimentMapper(SearchCriteriaQuerySentimentsEnum.positive);

        this.previousPeriodTotalPositiveSeries = new ReportSeriesModel();
        this.previousPeriodTotalPositiveSeries.mentions.isPreviousPeriod = true;
        this.previousPeriodTotalPositiveSeries.mentions.facetGenerator = () => {
            return {
                facet: [MentionSearchFacetTypesEnum.sentiment],
                identifier: ReportSeriesFacetGeneratorEnum.facet
            };
        };
        this.previousPeriodTotalPositiveSeries.mentions.dataMapper = getSentimentMapper(SearchCriteriaQuerySentimentsEnum.positive);


        this.totalNeutralSeries = new ReportSeriesModel();
        this.totalNeutralSeries.label = 'Reports.sentiment.neutral';
        this.totalNeutralSeries.mentions.facetGenerator = () => {
            return {
                facet: [MentionSearchFacetTypesEnum.sentiment],
                identifier: ReportSeriesFacetGeneratorEnum.facet
            };
        };
        this.totalNeutralSeries.mentions.dataMapper = getSentimentMapper(SearchCriteriaQuerySentimentsEnum.neutral);

        this.previousPeriodTotalNeutralSeries = new ReportSeriesModel();
        this.previousPeriodTotalNeutralSeries.mentions.isPreviousPeriod = true;
        this.previousPeriodTotalNeutralSeries.mentions.facetGenerator = () => {
            return {
                facet: [MentionSearchFacetTypesEnum.sentiment],
                identifier: ReportSeriesFacetGeneratorEnum.facet
            };
        };
        this.previousPeriodTotalNeutralSeries.mentions.dataMapper = getSentimentMapper(SearchCriteriaQuerySentimentsEnum.neutral);


        this.totalNegativeSeries = new ReportSeriesModel();
        this.totalNegativeSeries.label = 'Reports.sentiment.negative';
        this.totalNegativeSeries.mentions.facetGenerator = () => {
            return {
                facet: [MentionSearchFacetTypesEnum.sentiment],
                identifier: ReportSeriesFacetGeneratorEnum.facet
            };
        };
        this.totalNegativeSeries.mentions.dataMapper = getSentimentMapper(SearchCriteriaQuerySentimentsEnum.negative);


        this.previousPeriodTotalNegativeSeries = new ReportSeriesModel();
        this.previousPeriodTotalNegativeSeries.mentions.isPreviousPeriod = true;
        this.previousPeriodTotalNegativeSeries.mentions.facetGenerator = () => {
            return {
                facet: [MentionSearchFacetTypesEnum.sentiment],
                identifier: ReportSeriesFacetGeneratorEnum.facet
            };
        };
        this.previousPeriodTotalNegativeSeries.mentions.dataMapper = getSentimentMapper(SearchCriteriaQuerySentimentsEnum.negative);
    }

    initializeAll(): void {
        if (this.hasInitializedSeries) {
            this.deregisterSeries();
        }
        this.initializeCards();
        this.reportsDashboardSearchService.fulfillSeries(
            [
                this.drilldownSeries,
                this.totalVolumeSeries,
                this.previousPeriodTotalVolumeSeries,
                this.totalImpressionsSeries,
                this.previousPeriodTotalImpressionsSeries,
                this.totalAveSeries,
                this.previousPeriodTotalAveSeries,

                this.totalPositiveSeries,
                this.previousPeriodTotalPositiveSeries,
                this.totalNeutralSeries,
                this.previousPeriodTotalNeutralSeries,
                this.totalNegativeSeries,
                this.previousPeriodTotalNegativeSeries,
            ]
        );
        this.hasInitializedSeries = true;
    }

    deregisterSeries() {
        this.reportsDashboardSearchService.deregisterSeries([
            this.drilldownSeries,
            this.totalVolumeSeries,
            this.previousPeriodTotalVolumeSeries,
            this.totalImpressionsSeries,
            this.previousPeriodTotalImpressionsSeries,
            this.totalAveSeries,
            this.previousPeriodTotalAveSeries,

            this.totalPositiveSeries,
            this.previousPeriodTotalPositiveSeries,
            this.totalNeutralSeries,
            this.previousPeriodTotalNeutralSeries,
            this.totalNegativeSeries,
            this.previousPeriodTotalNegativeSeries,
        ]);
        this.hasInitializedSeries = false;
    }

    openBulkDialog(): void {
        const mentionIds = this.selectedMentions?.map(x => x.mentionId) || [];
        const bulkActionData: DialogIoModel = {
            inputs: {
                mentionIds: mentionIds,
                initialFilters: this.reportsDashboardSearchService.generateFilterSearchCriteria(),
                route: new MonitoringRouteModel(RouteType.report),
                dateQuery: this.dateQuery,
                search: this.topicSearch,
                source: this.source
            },
            outputs: {
                changes: async () => {
                    // in case mention counts have changed
                    this.reportsDashboardSearchService.search(true, true);
                }
            }
        };
        this.coreDialogService.open(MonitoringBulkActionDialogComponent, bulkActionData);
    }

    navigateToMonitor(): void {
        const searchCriteria = this.reportsDashboardSearchService.generateFilterSearchCriteria();
        let url = '';
        if (this.drilldownSeries?.mentions) {
            this.sourceSelected = true;
            if (this.drilldownSeries.mentions.folderId) {
                url = `Monitoring/mentions/folder/${this.drilldownSeries.mentions.folderId}`;
            } else if (this.drilldownSeries.mentions.topicId) {
                url = `Monitoring/topics/topic/${this.drilldownSeries.mentions.topicId}`;
            } else if (this.drilldownSeries.mentions.mediaSubscriptionId) {
                url = `Monitoring/subscriptions/subscription/${this.drilldownSeries.mentions.mediaSubscriptionId}`;
            } else if (this.drilldownSeries.mentions.tagId) {
                url = 'Monitoring/mentions/saved';
                searchCriteria.query.tag.include = [this.drilldownSeries.mentions.tagId];
            } else if (this.drilldownSeries.mentions.tagGroupId) {
                url = 'Monitoring/mentions/saved';
                searchCriteria.query.tagGroup.include = [this.drilldownSeries.mentions.tagGroupId];
            } else if (this.drilldownSeries.mentions.sourceGroupId) {
                url = 'Monitoring/mentions/saved';
                searchCriteria.query.sourceGroup.include = [this.drilldownSeries.mentions.sourceGroupId];
            } else if (this.drilldownSeries.mentions.aiAgentId) {
                url = agentSectionRoute(this.drilldownSeries.mentions.aiAgentId, AgentRouteSectionEnum.mentions).substring(1);
            } else if (this.drilldownSeries.mentions.themeId) {
                url = `Social/themes/theme/${this.drilldownSeries.mentions.themeId}/postFeed`;
            } else if (this.drilldownSeries.mentions.socialTopicId) {
                if (this.drilldownSeries.styles?.socialTopicThemeIds?.length) {
                    url = `Social/themes/theme/${this.drilldownSeries.styles?.socialTopicThemeIds[0]}/postFeed`;
                    searchCriteria.query.agent.include = [this.drilldownSeries.mentions.socialTopicId];
                } else {
                    return null;
                }
            } else {
                searchCriteria.query = MentionSearchQueryModel.createFiltered(this.mentionSearch.query, searchCriteria.query);
                if (this.mentionSearch.isAccountSearch) {
                    url = 'Monitoring/mentions/saved';
                } else {
                    url = 'Monitoring/search/results';
                }
            }
        }

        url += '?filters=' + MentionSearchCriteriaModel.toFilterQueryString(searchCriteria);

        window.open(url, '_blank');
    }

    /**
     * Sets the preview block size so it will display it's contents at the right size
     */
    setBlockSize(): void {
        if (!this.block?.type?.key) {
            return;
        }

        const gridSettings = this.pageBuilderService.gridSettings;
        let cols = reportChartInfoMap.get(this.block.type.key as ReportBlockTypeEnum)?.dimensions.width ?? 1;
        let rows = reportChartInfoMap.get(this.block.type.key as ReportBlockTypeEnum)?.dimensions.height ?? 1;
        // we would like the charts to be bigger in the drilldown
        rows = Math.max(rows, 4);

        // special settings for dashboard charts
        if (this.block.type.key === ReportBlockTypeEnum.RECENT_TOPICS) {
            cols = 4;
            rows = 3;
        }

        this.blockWidth = cols * gridSettings.fixedColWidth + (cols - 1) * gridSettings.margin;
        this.blockHeight = Math.min(this.scrollPreventingBlockHeight, rows * gridSettings.fixedRowHeight + (rows - 1) * gridSettings.margin - 20);
    }

    setChartDimensions(): void {
        this.blockWidth = 800;
        this.blockHeight = this.scrollPreventingBlockHeight;
    }

    mentionCardClicked(event: MentionCardClickedEvent) {
        if (!event || !event.mention) {
            return;
        }

        if (event.eventType !== 'mention') {
            this.mentionsService.setFocusedMention(event.mention);
        }

        this.setRHPContextFromMention(event.mention);
        this.openMentionDetailsTakeOver(event.eventType);
    }

    private openMentionDetailsTakeOver(eventType: 'contact' | 'outlet' | 'mention') {
        const io: DialogIoModel = {
            inputs: {
                focusTab: eventType,
                fromReports: true
            },
            outputs: {}
        };

        this.coreDialogService.open(MentionDetailsTakeOverPanelComponent, io, this.injector);
    }

    private setRHPContextFromMention(mention: Mention) {
        if (mention.author?.uuid) {
            this.targetingRhpContextsService.setFullProfileContactById(mention.author.uuid);
        } else {
            this.targetingRhpContextsService.clearContact();
        }
        if (mention.publication?.uuid) {
            this.targetingRhpContextsService.setFullProfileOutletById(mention.publication.uuid);
        } else {
            this.targetingRhpContextsService.clearOutlet();
        }
    }

    openTargetingEntityTakeover(event: EntityTakeoverModel) {
        this.targetingRhpDialogService.openTakeOver({
            inputs: {
                contactId: event.contactId,
                outletId: event.outletId,
                entityType: event.entityType,
                isPrivate: event.isPrivate,
                fullHeight: true
            }
        });
    }

    onKeyMessageGroupsChanged(groups: KeyMessageGroupApi[]): void {
        this.sharedKeyMessageGroups = [...groups];
    }

    tabIndexChange(tabIndex: ChartDrillDownTabEnum) {
        const previousTabIndex = this.selectedTabIndex;
        this.selectedTabIndex = tabIndex;
        this.isCoverageInsightActive = tabIndex === ChartDrillDownTabEnum.coverageInsights;
        this.chart?.amchart?.draw();

        const leftChart = this.am5Charts[previousTabIndex];
        if (leftChart && previousTabIndex !== tabIndex) {
            this.am5Charts[previousTabIndex] = leftChart.clone();
        }
    }

    /**
     * Performs a targeting search with respect to the searchMode
     * These targeting calls must be made separately as facet totals returned corresponds to entity type (searchMode)
     */
    tabChangeContactOutlet(tabIndex: ChartContactOutletTabEnum) {
        this.selectedContactOutletIndex = tabIndex;
        if (!this.mentionSearch) {
            return;
        }

        this.doContactOutletSearches();
    }

    doContactOutletSearches() {
        const search = new TargetingSearch();
        const fullSearchCriteria = this.reportsDashboardSearchService.getMentionSearchCriteriaPayload();
        if (fullSearchCriteria) {
            if (this.selectedContactOutletIndex === ChartContactOutletTabEnum.contactList) {
                search.searchMode = SearchModeEnum.contact;
                fullSearchCriteria.facets.push(MentionSearchFacetTypesEnum.contactUuid);
                fullSearchCriteria.facets = fullSearchCriteria.facets.filter(facets => facets !== MentionSearchFacetTypesEnum.outletUuid);
            } else {
                search.searchMode = SearchModeEnum.outlet;
                fullSearchCriteria.facets.push(MentionSearchFacetTypesEnum.outletUuid);
                fullSearchCriteria.facets = fullSearchCriteria.facets.filter(facets => facets !== MentionSearchFacetTypesEnum.contactUuid);
            }

            const searchRequestJSON = fullSearchCriteria.clone().getApiEntity();
            if (searchRequestJSON.filterQuery) {
                delete searchRequestJSON.filterQuery.publicationDate;
                delete searchRequestJSON.filterQuery.harvestedDate;
            }
            search.advMonQuery = {
                searchRequestJSON: JSON.stringify(searchRequestJSON),
                isSavedSearch: fullSearchCriteria.isAccountSearch
            };
            this.targetingSearchService.performSearch(search);
        }
    }

    /**
     * An agent's analytics narrows its search to the sources and ad hoc runs ticked in the agent's
     * sidebar. In the drill down those are the Agents filter's to change, so they move out of the
     * base search and into the filters - left in the base, any other choice in the filter would
     * conflict with it.
     */
    private moveAgentScopeToFilters(query: MentionSearchQueryModel, filterQuery: MentionSearchQueryModel): MentionSearchQueryModel {
        const scopeFields: ('aiAgentSource' | 'aiAgentAdhoc')[] = ['aiAgentSource', 'aiAgentAdhoc'];
        const isNarrowed = scopeFields.some(field => query[field]?.include?.length || query[field]?.exclude?.length);

        if (query.aiAgent?.include?.length !== 1 || !isNarrowed) {
            return filterQuery;
        }

        const filters = filterQuery ?? new MentionSearchQueryModel();

        filters.aiAgent = { include: query.aiAgent.include.slice(), exclude: [] };
        scopeFields.forEach(field => {
            filters[field] = {
                include: query[field]?.include?.slice() ?? [],
                exclude: query[field]?.exclude?.slice() ?? []
            };
            query[field] = { include: [], exclude: [] };
        });

        return filters;
    }

    isSavedSource(): boolean {
        return !!(this.drilldownSeries?.mentions.folderId ||
            this.drilldownSeries?.mentions.tagId ||
            this.drilldownSeries?.mentions.tagGroupId ||
            this.drilldownSeries?.mentions.sourceGroupId ||
            this.drilldownSeries?.mentions.aiAgentId);
    }

    close(overlayVisibility: boolean): void {
        if (!overlayVisibility) {
            this.closeDialog();
        }
        if (!this.block?.equals(this.originalBlock)) {
            this.clearSeriesData(this.block, this.originalBlock);
        }
        this.reportsDashboardSearchService.clearSearch();
        this.reportsDashboardSearchService.clearFilters();
        this.reportsDashboardSearchService.applyFilters(false);
    }

    ngOnDestroy() {
        this.reportsChartDetailService.chartDetailsDialogId = null;
        this.subscriptions.forEach(sub => sub.unsubscribe());
        if (this.seriesChartProvider) {
            this.seriesChartProvider.unsubscribe();
            this.seriesChartProvider = null;
        }

        if (this.hasInitializedSeries) {
            this.deregisterSeries();
        }
    }

    private setDateQueryOnSearchCriteria(dateQuery: DateQueryModel, searchCriteriaModel: MentionSearchCriteriaModel) {
        if (dateQuery) {
            if (!dateQuery.type) {
                this.reportsDashboardSearchService.setDateQuery(DateQueryModel.getAllQuery());
            } else {
                this.reportsDashboardSearchService.setDateQuery(dateQuery);
            }
            if (searchCriteriaModel.filterQuery?.dateQuery) {
                searchCriteriaModel.filterQuery.dateQuery = dateQuery;
            } else {
                if (!searchCriteriaModel.query) {
                    searchCriteriaModel.query = new MentionSearchQueryModel();
                }
                searchCriteriaModel.query.dateQuery = dateQuery;
            }
        }
    }

    updateChartNoData(event: boolean) {
        this.chartNoData = event;
    }
}

export const getSentimentMapper = (sentiment: SearchCriteriaQuerySentimentsEnum) => {
    return (response) => {
        const val: DataPointModel[] = [{
            count: 0
        }];

        if (response && response.facetResults) {
            for (const facetType of response.facetResults) {
                if (facetType.field !== MentionSearchFacetTypesEnum.sentiment) {
                    continue;
                }

                for (const facetValue of facetType.values) {
                    const floatValue = parseFloat(facetValue.value);

                    if (isNaN(floatValue)) {
                        continue;
                    }

                    if ((sentiment === SearchCriteriaQuerySentimentsEnum.negative) && (floatValue <= -0.3)) {
                        val[0].count += facetValue.count;
                    } else if ((sentiment === SearchCriteriaQuerySentimentsEnum.positive) && (floatValue >= 0.3)) {
                        val[0].count += facetValue.count;
                    } else if ((sentiment === SearchCriteriaQuerySentimentsEnum.neutral) && ((floatValue > -0.3) && (floatValue < 0.3))) {
                        val[0].count += facetValue.count;
                    }
                }
            }
        }

        return val;
    };
};
